import Vue from 'vue'
import dealer from '../../apis/dealer'
import {
  RESET_STATE,
  REGISTER_MYDEALER_REQUEST,
  REGISTER_MYDEALER_SUCCESS,
  REGISTER_MYDEALER_FAILURE,
  UPDATE_MYDEALER_REQUEST,
  UPDATE_MYDEALER_SUCCESS,
  UPDATE_MYDEALER_FAILURE
} from '../mutation-types'

let initialState = {
  status: {
    registerMyDealer: null,
    updateMyDealer: null
  }
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  statusRegisterMyDealer: function (state) {
    return state.status.registerMyDealer
  },
  statusUpdateMyDealer: function (state) {
    return state.status.updateMyDealer
  }
}

// actions
const actions = {
  registerMyDealer: function ({commit, dispatch}, {dealerId, name, zip, address1, address2, phone, email, lat, lng}) {
    commit(REGISTER_MYDEALER_REQUEST)
    return new Promise((resolve, reject) => {
      dealer.registerDealer({dealerId, name, zip, address1, address2, phone, email, lat, lng}).then(
        res => {
          commit(REGISTER_MYDEALER_SUCCESS)
          resolve()
        },
        err => {
          commit(REGISTER_MYDEALER_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  updateMyDealer: function ({commit, dispatch}, {dealerId, name, zip, address1, address2, phone, email, lat, lng}) {
    commit(UPDATE_MYDEALER_REQUEST)
    return new Promise((resolve, reject) => {
      dealer.updateDealer({dealerId, name, zip, address1, address2, phone, email, lat, lng}).then(
        res => {
          commit(UPDATE_MYDEALER_SUCCESS)
          resolve()
        },
        err => {
          commit(UPDATE_MYDEALER_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  acceptMyDealerInvitation: function ({commit, dispatch}, {dealerId, memberId}) {
    return new Promise((resolve, reject) => {
      dealer.acceptDealerMemberInvitation({dealerId, memberId}).then(
        res => {
          resolve()
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  }
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [REGISTER_MYDEALER_REQUEST]: function (state) {
    state.status = {...state.status, 'registerMyDealer': 'requested'}
  },
  [REGISTER_MYDEALER_SUCCESS]: function (state) {
    state.status = {...state.status, 'registerMyDealer': 'successful'}
  },
  [REGISTER_MYDEALER_FAILURE]: function (state) {
    state.status = {...state.status, 'registerMyDealer': 'failed'}
  },
  [UPDATE_MYDEALER_REQUEST]: function (state) {
    state.status = {...state.status, 'updateMyDealer': 'requested'}
  },
  [UPDATE_MYDEALER_SUCCESS]: function (state) {
    state.status = {...state.status, 'updateMyDealer': 'successful'}
  },
  [UPDATE_MYDEALER_FAILURE]: function (state) {
    state.status = {...state.status, 'updateMyDealer': 'failed'}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/myDealer.js